import { Box, CircularProgress } from '@mui/material';

export default function Loader() {
	return (
		<Box
			display="flex"
			alignItems="center"
			justifyContent="center"
			minHeight="10vh"
		>
			<CircularProgress />
		</Box>
	);
}
